import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { go } from '@ngrx/router-store';

import { AppState } from '../../../store/app-state';

@Injectable()
export class RouterService {

  constructor(private store: Store<AppState>) { }

  go(path: string) {
    return this.store.dispatch(go(path));
  }

  back() { }

  forward() { }

}



// WEBPACK FOOTER //
// ./src/app/core/service/core/router.sevice.ts